import React from 'react';
import Logo from '../../../../app/js/components/loggedout/Header/logo';
import * as S from "./style";
import { ContainerWrapper } from "../../common/styled-components/styled-components"

const Header = () => {
    return (
        <ContainerWrapper>
            <S.SplashLogo>
                <Logo />
            </S.SplashLogo>
        </ContainerWrapper>
    )
}

export default Header;